export default function CDOLogo({ size = 36, withText = true }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="cdo-logo">
      <div
        className="rounded-xl flex items-center justify-center cdo-gradient text-white font-display font-bold tracking-tight"
        style={{ width: size, height: size, fontSize: size * 0.35, boxShadow: "0 6px 18px -4px rgba(124, 58, 237, 0.5)" }}
      >
        CDO
      </div>
      {withText && (
        <div className="leading-none">
          <div className="font-display text-base font-bold tracking-tight" style={{ color: "var(--text-on-sidebar)" }}>CDO Agency</div>
          <div className="text-[10px] font-mono uppercase tracking-[0.18em] mt-1" style={{ color: "var(--text-on-sidebar-muted)" }}>Social Media OS</div>
        </div>
      )}
    </div>
  );
}
